import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IGiftCodeDetails } from "../giftcodeModel";
import moment from "moment";

export const getAllGiftCodes = createAsyncThunk(
  "GiftCode/FindAllGiftCode",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/FindAllGiftCode`,
        {
          Limit: 1000,
          Skip: 0,
          FilterGiftCode: "",
          FromDate: "",
          ToDate: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching GiftCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const generateGiftCode = createAsyncThunk(
  "GiftCode/GenerateGiftCode",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/GiftCode/GenerateGiftCode`
      );
      return response.data?.Data?.GiftCode || "";
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PromoCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createGiftCode = createAsyncThunk(
  "GiftCode/InsertGiftCode",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/InsertGiftCode`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching GiftCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateGiftCode = createAsyncThunk(
  "GiftCode/UpdateGiftCode",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/UpdateGiftCode`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating GiftCode:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getGiftCodeById = createAsyncThunk(
  "GiftCode/FindByIDGiftCode",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/FindByIDGiftCode`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        GiftCode: result.GiftCode,
        FromDate: result.FromDate ? moment(result.FromDate, "").toDate() : "",
        ToDate: result.ToDate ? moment(result.ToDate).toDate() : "",
        Amount: result.Amount,
        IsActive: result.IsActive ? 1 : 2,
        UsageCount: result?.UsageCount,
        MinAmtUsage: result?.MinAmtUsage,
        MaxAmtUsage: result?.MaxAmtUsage,
        AmountType: result?.AmountType,
        FlightTicketAmt: result?.FlightTicketAmt,
        HotelBookingAmt: result?.HotelBookingAmt,
        AssignUserID: result?.AssignUserID,
        UserMobile: result?.UserMobile,
        AssignUser: result?.AssignUser,
        OnlyUsedInWallet: result?.OnlyUsedInWallet || false,
        Type: result?.IsAuto ? "Auto" : "Manual",
      } as IGiftCodeDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching GiftCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const giftCodeLedger = createAsyncThunk(
  "GiftCode/GiftCodeLedger",
  async (GiftCode: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/GiftCodeLedger`,
        { GiftCode: GiftCode }
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching GiftCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteGiftCode = createAsyncThunk(
  "GiftCode/DeleteGiftCode",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/DeleteGiftCode`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting GiftCode:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const giftcodeActiveInactive = createAsyncThunk(
  "GiftCode/ActiveInActiveGiftCode",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/ActiveInActiveGiftCode`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive GiftCode:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
